import styled from 'styled-components';
import shadow from '../../assets/images/shadow.png';

const StyledShadow = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 560px;
	height: 560px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export { StyledShadow };
